import { useState, useRef, useEffect } from "react";
import { Globe, Check } from "lucide-react";
import { useLang } from "../i18n/LanguageProvider";

export const LanguageSwitcher = ({ compact = false }) => {
  const { lang, setLang, languages } = useLang();
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const onClick = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener("mousedown", onClick);
    return () => document.removeEventListener("mousedown", onClick);
    // setOpen from useState is stable; onClick is scoped inside the effect.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const current = languages.find((l) => l.code === lang) || languages[0];

  return (
    <div ref={ref} className="relative">
      <button
        onClick={() => setOpen((v) => !v)}
        data-testid="lang-switcher"
        aria-label="Change language"
        className="flex items-center gap-2 text-white/80 hover:text-gold transition-colors"
      >
        <Globe size={14} strokeWidth={1.4} />
        <span className="text-[11px] tracking-[0.28em] uppercase">{current.label}</span>
      </button>
      {open && (
        <div
          className="absolute right-0 mt-3 min-w-[160px] glass border border-white/10 py-2 z-50"
          data-testid="lang-menu"
        >
          {languages.map((l) => (
            <button
              key={l.code}
              onClick={() => {
                setLang(l.code);
                setOpen(false);
              }}
              data-testid={`lang-option-${l.code}`}
              className={`w-full flex items-center justify-between px-4 py-2 text-left text-sm hover:bg-white/5 ${
                l.code === lang ? "text-gold" : "text-white/85"
              }`}
            >
              <span className="flex items-center gap-3">
                <span className="text-[11px] tracking-[0.28em] uppercase w-6">{l.label}</span>
                <span className="text-xs">{l.full}</span>
              </span>
              {l.code === lang && <Check size={12} className="text-gold" />}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default LanguageSwitcher;
